class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = '/cart';
    this.checkboxUpsellVariantId1 = this.getUpsellCheckboxVariantId('cart-upsell-checkbox-1');
    this.checkboxUpsellVariantId2 = this.getUpsellCheckboxVariantId('cart-upsell-checkbox-2');
    this.initEventDelegation();
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this));
    this.updateCheckboxState();
  }

  initEventDelegation() {
    document.body.addEventListener('change', (event) => {
      if (event.target.id === 'cart-upsell-checkbox-1') {
        const isChecked = event.target.checked;
        if (isChecked) {
          this.addUpsellCheckboxToCart(this.checkboxUpsellVariantId1);
        } else {
          this.removeUpsellCheckboxFromCart(this.checkboxUpsellVariantId1);
        }
      }

      if (event.target.id === 'cart-upsell-checkbox-2') {
        const isChecked = event.target.checked;
        if (isChecked) {
          this.addUpsellCheckboxToCart(this.checkboxUpsellVariantId2);
        } else {
          this.removeUpsellCheckboxFromCart(this.checkboxUpsellVariantId2);
        }
      }
    });
  }

  getUpsellCheckboxVariantId(checkboxId) {
    return document.querySelector(`#${checkboxId}`)?.getAttribute('data-variant-id');
  }

  updateCheckboxState() {
    fetch(`${this.baseUrl}.js`)
      .then(response => response.json())
      .then(cart => {
        const hasUpsellCheckbox1 = cart.items.some(item => item.variant_id.toString() === this.checkboxUpsellVariantId1);
        const checkboxUpsellCheckbox1 = document.querySelector('#cart-upsell-checkbox-1');
        if (checkboxUpsellCheckbox1) {
          checkboxUpsellCheckbox1.checked = hasUpsellCheckbox1;
        }

        const hasUpsellCheckbox2 = cart.items.some(item => item.variant_id.toString() === this.checkboxUpsellVariantId2);
        const checkboxUpsellCheckbox2 = document.querySelector('#cart-upsell-checkbox-2');
        if (checkboxUpsellCheckbox2) {
          checkboxUpsellCheckbox2.checked = hasUpsellCheckbox2;
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  handleCartUpdate() {
    setTimeout(() => this.updateCheckboxState(), 500); 
  }

  addUpsellCheckboxToCart(variantId) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  console.log('Attempting to add variant to cart:', variantId);  // Step 1: Check if we reach here

  fetch(`${this.baseUrl}/add.js`, {
    method: 'POST',
    body: formData
  })
  .then(response => {
    console.log('Response from cart add request:', response);  // Step 2: Check the fetch response

    if (response.ok) {
      console.log('Dispatching cartUpdatedEvent');  // Step 3: Check if we reach here before dispatching the event

      // Define the event before dispatching it
      const cartUpdatedEvent = new CustomEvent('cartUpdated', {
        detail: {
          message: 'Cart was updated',
        },
      });

      document.dispatchEvent(cartUpdatedEvent);  // Step 4: Event dispatch should happen here
      if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
        this.cartItemsInstance.onCartUpdate();
        this.onCartUpdateCheckboxUpsell();
      }
    }
    return response.json();
  })
  .catch(error => {
    console.error('Error adding cart upsell:', error);
  });
}


  removeUpsellCheckboxFromCart(variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineItemIndex = cart.items.findIndex(item => item.variant_id.toString() === variantId);
        if (lineItemIndex !== -1) {
          const line = lineItemIndex + 1;
          this.cartItemsInstance.updateQuantity(line, 0, null, null);
        } else {
          console.error('Cart upsell product not found in cart.');
        }
      })
      .catch(error => {
        console.error('Error fetching cart for cart upsell removal:', error);
      });
  }

  getSectionsToRenderCheckboxUpsell() {
    const mainCartFooter = document.getElementById('main-cart-footer');
    const sections = [];

    // Conditionally push the 'main-cart-footer' section if it exists
    if (mainCartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '#main-cart-footer .js-contents',
      });
    }

    // Add the 'cart-icon-bubble' section
    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '#cart-icon-bubble',
    });

    return sections;
  }

  onCartUpdateCheckboxUpsell() {
    this.getSectionsToRenderCheckboxUpsell().forEach(section => {
      fetch(`${routes.cart_url}?section_id=${section.section}`)
        .then(response => response.text())
        .then(html => {
          const container = document.querySelector(section.selector);
          if (!container) {
            console.error(`Container not found for selector: ${section.selector}`);
            return;
          }
          if (section.id === 'main-cart-footer') {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const jsContents = doc.querySelector('.js-contents');
  
            if (jsContents) {
              container.innerHTML = jsContents.innerHTML;
            } else {
              console.error(`.js-contents not found in fetched HTML for section: ${section.id}`);
            }
          } else if (section.id === 'cart-icon-bubble') {
            container.innerHTML = html;
          }
        })
        .catch(error => console.error(`Error updating section ${section.id}:`, error));
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const cartItemsInstance = document.querySelector('cart-items');
  const cartDrawerItemsInstance = document.querySelector('cart-drawer-items');
  let activeCartInstance = cartDrawerItemsInstance || cartItemsInstance;
  if (activeCartInstance) {
    new CartCheckboxUpsell(activeCartInstance);
  } else {
    console.log("Neither cart-items nor cart-drawer-items found in the DOM.");
  }
});
